module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKklEQVQ4ja2TTY6CQBSEv9dxo20iMjdhDqIHkHgK4gYTFm6MF3DbgQPoPRxvMsSFLSwMzAbiIPgzyVTSSae6XnW9RQlAHMcTa20IfAAFz6GAb631yvf9vRhjJlmW7V4MdUJrPe1lWbasidPpRFmWT4dEBMdxALDWLnuAWw8vFou3fl6v17WJq6h2LopXq9/wS1v07h+PxyNxHDMYDBr85XLB9308z2vwLQPP81qiZ+hMkCRJZ4LZbPb/CdTbygdoJQCIoghrLSICQFmWjEYjwjB8bKDULYy1ls1m0xAGQdCZQFWH4XCIMaZlVqNOc3dXst1uD8AnwPV65Xw+4zgOaZo2DFzXJU1TRITxeFzTX2KMmeR5vnvVgS5oracCUDXyT3Xu9/ur+Xy+/wGfSHNWSZ5srQAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/fav-save.png
 ** module id = 212
 ** module chunks = 0 1
 **/